import { Type } from '@angular/core';

import { FieldWrapper } from '@ngx-formly/core';

import { CardWrapperComponent } from './card-wrapper/card-wrapper.component';
import { ColumnWrapperComponent } from './column-wrapper/column-wrapper.component';
import { DatasheetSectionWrapperComponent } from './datasheet-section-wrapper/datasheet-section-wrapper.component';
import { GalleryWrapperComponent } from './gallery-wrapper/gallery-wrapper.component';
import { HeadlessTableWrapperComponent } from './headless-table-wrapper/headless-table-wrapper.component';
import { LayoutWrapperComponent } from './layout-wrapper/layout-wrapper.component';
import { ListWrapperComponent } from './list-wrapper/list-wrapper.component';
import { RowWrapperComponent } from './row-wrapper/row-wrapper.component';
import { TabWrapperComponent } from './tab-wrapper/tab-wrapper.component';
import { TableWrapperComponent } from './table-wrapper/table-wrapper.component';
import { TextWrapperComponent } from './text-wrapper/text-wrapper.component';
import { WorkingConditionWrapperComponent } from './working-condition-wrapper/working-condition-wrapper.component';

// Define WrapperOption type locally since it's no longer directly importable from@ngx-formly
export interface WrapperOption {
  name: string;
  component: Type<FieldWrapper>;
  types?: string[];
}

export const wrappers: WrapperOption[] = [
  { name: 'working-condition', component: WorkingConditionWrapperComponent },
  { name: 'row', component: RowWrapperComponent },
  { name: 'tab', component: TabWrapperComponent },
  { name: 'text', component: TextWrapperComponent },
  { name: 'list', component: ListWrapperComponent },
  { name: 'table', component: HeadlessTableWrapperComponent },
  { name: 'advanced-table', component: TableWrapperComponent },
  { name: 'gallery', component: GalleryWrapperComponent },
  { name: 'datasheet-section', component: DatasheetSectionWrapperComponent },
  { name: 'card', component: CardWrapperComponent },
  { name: 'column', component: ColumnWrapperComponent },
  { name: 'layout', component: LayoutWrapperComponent },
];

export const wrapperComponents = [
  WorkingConditionWrapperComponent,
  RowWrapperComponent,
  TabWrapperComponent,
  TextWrapperComponent,
  ListWrapperComponent,
  HeadlessTableWrapperComponent,
  TableWrapperComponent,
  GalleryWrapperComponent,
  DatasheetSectionWrapperComponent,
  CardWrapperComponent,
  ColumnWrapperComponent,
  LayoutWrapperComponent,
];
